import * as React from "react";
import { graphql } from "gatsby";
import Seo from "../components/Seo";

import { productPageData } from "../data/page-tpl-product.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";
import Section from "../components/Section";

import HeroProduct from "../componentsSections/HeroProduct";
import ConnectivityLogos from "../components/ConnectivityLogos";
import AnchorNav from "../componentsSections/AnchorNav";
import SocialProof from "../componentsSections/SocialProof";
import SecuritySection from "../componentsSections/SecuritySection";
import ImageSectionsGroup from "../components/ImageSectionsGroup";

const ProductPage = ({ pageContext: { id }, location }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = productPageData(id);

    return (
        <Layout
            pageTitle={seoPageData.title}
            navbarVariant={pageData.hero?.image ? "transparent" : undefined}
        >
            <Seo post={seoPageData} pathname={location.pathname} />

            <HeroProduct {...pageData.hero} />

            <Section className="-mobile-full">
                <AnchorNav items={pageData.anchorNav} />
            </Section>

            <Section className="-mobile-full">
                <ImageSectionsGroup imageSections={pageData.featureSections} />
            </Section>

            <Section>
                <SocialProof
                    trustedByHeader={pageData.testimonials?.header}
                    testimonials={pageData.testimonials?.items}
                    mode="testimonials"
                    className="-light"
                    autoplayDelay={3000}
                />
            </Section>

            <Section className="-mobile-full">
                <SecuritySection {...pageData.securitySection} />
            </Section>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default ProductPage;
